import { PROJECT_TEMPLATE_SUBTASK, PROJECT_TEMPLATE_TASK } from "~/pages/ProjectTemplates/utils";
import { EDIT_PROJECT_TEMPLATE_ELEMENT_SUCCESS } from "~/store/action_types";
import { unassignClientFromProjectTemplateSubtasks } from "~/store/actions/actions.projectTemplateElements";
import { isClient } from "~/utils/userHelper";

const projectTemplateElementsMiddleware =
  ({ dispatch, getState }) =>
  (next) =>
  (action) => {
    const { type, response } = action;

    switch (type) {
      case EDIT_PROJECT_TEMPLATE_ELEMENT_SUCCESS: {
        if (response) {
          const { single = {} } = response;
          const { id, class: elementType, is_hidden_from_clients: isHiddenFromClients } = single;

          if (
            elementType === PROJECT_TEMPLATE_TASK &&
            isHiddenFromClients === true &&
            getState()?.project_template_elements?.[id]?.is_hidden_from_clients === false
          ) {
            const state = getState();
            const users = state.users || {};
            const projectTemplateElements = state.project_template_elements || {};
            const subtaskIdsToUnassign = [];

            Object.keys(projectTemplateElements).forEach((elementId) => {
              const element = projectTemplateElements[elementId];

              if (element.class === PROJECT_TEMPLATE_SUBTASK && element.task_id === id && element.assignee_id > 0) {
                const assignee = users.toJS?.()?.[element.assignee_id] || users[element.assignee_id];

                if (assignee && isClient(assignee)) {
                  subtaskIdsToUnassign.push(elementId);
                }
              }
            });

            if (subtaskIdsToUnassign.length > 0) {
              dispatch(unassignClientFromProjectTemplateSubtasks(subtaskIdsToUnassign));
            }
          }
        }

        return next(action);
      }
      default:
        return next(action);
    }
  };

export default projectTemplateElementsMiddleware;
